// Stores.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "./styles";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdb-react-ui-kit";
import api from "../../services/api";

function Stores() {
  const navigate = useNavigate();

  function handleRowClick(store) {
    navigate(`/storemap?businessUnitCode=${store.business_unit_code}`);
  }

  const [stores, setStores] = useState();

  useEffect(() => {
    api.get("/stores").then((response) => setStores(response.data));
  }, [stores]);

  return (
    <Container>
      <h3>Lojas</h3>

      <MDBTable align="start" hover>
        <MDBTableHead>
          <tr>
            <th scope="col">Código</th>
            <th scope="col">Cidade</th>
          </tr>
        </MDBTableHead>
        <MDBTableBody>
          {stores?.map((store) => (
            <tr className="table-light" onClick={() => handleRowClick(store)}>
              <td>{store.business_unit_code}</td>
              <td>{store.location}</td>
            </tr>
          ))}
        </MDBTableBody>
      </MDBTable>
    </Container>
  );
}

export default Stores;
